import asparagusIcon from '@/assets/emoji-asparagus.png';
import beetrootIcon from '@/assets/emoji-beetroot.png';
import brusselsSproutsIcon from '@/assets/emoji-brussels-sprouts.png';
import cauliflowerIcon from '@/assets/emoji-cauliflower.png';
import celeriacIcon from '@/assets/emoji-celeriac.png';
import kohlrabiIcon from '@/assets/emoji-kohlrabi.png';
import parsnipIcon from '@/assets/emoji-parsnip.png';
import radishIcon from '@/assets/emoji-radish.png';
import squashIcon from '@/assets/emoji-squash.png';
import swissChardIcon from '@/assets/emoji-swiss-chard.png';
import turnipIcon from '@/assets/emoji-turnip.png';
import artichokeIcon from '@/assets/emoji-artichoke.png';
import leekIcon from '@/assets/emoji-leek.png';
import nasturtiumIcon from '@/assets/emoji-nasturtium.png';
import fennelIcon from '@/assets/emoji-fennel.png';
import blackberryIcon from '@/assets/emoji-blackberry.png';
import figIcon from '@/assets/emoji-fig.png';
import plumIcon from '@/assets/emoji-plum.png';
import redcurrantIcon from '@/assets/emoji-redcurrant.png';

// New watercolor companion icons
import basilCo from '@/assets/companion/basil.png';
import beansCo from '@/assets/companion/beans.png';
import cabbageCo from '@/assets/companion/cabbage.png';
import carrotCo from '@/assets/companion/carrot.png';
import courgetteCo from '@/assets/companion/courgette.png';
import cucumberCo from '@/assets/companion/cucumber.png';
import kaleCo from '@/assets/companion/kale.png';
import lettuceCo from '@/assets/companion/lettuce.png';
import marigoldCo from '@/assets/companion/marigold.png';
import nasturtiumCo from '@/assets/companion/nasturtium.png';
import onionCo from '@/assets/companion/onion.png';
import squashCo from '@/assets/companion/squash.png';
import sunflowerCo from '@/assets/companion/sunflower.png';
import sweetcornCo from '@/assets/companion/sweetcorn.png';
import tomatoCo from '@/assets/companion/tomato.png';
import pepperCo from '@/assets/companion/pepper.png';
import spinachCo from '@/assets/companion/spinach.png';
import garlicCo from '@/assets/companion/garlic.png';
import strawberryCo from '@/assets/companion/strawberry.png';
import chivesCo from '@/assets/companion/chives.png';
import dillCo from '@/assets/companion/dill.png';
import parsleyCo from '@/assets/companion/parsley.png';
import rosemaryCo from '@/assets/companion/rosemary.png';
import thymeCo from '@/assets/companion/thyme.png';
import sageCo from '@/assets/companion/sage.png';
import oreganoCo from '@/assets/companion/oregano.png';
import lavenderCo from '@/assets/companion/lavender.png';
import beetrootCo from '@/assets/companion/beetroot.png';
import radishCo from '@/assets/companion/radish.png';
import calendulaCo from '@/assets/companion/calendula.png';
import borageCo from '@/assets/companion/borage.png';
import raspberryCo from '@/assets/companion/raspberry.png';
import blackcurrantCo from '@/assets/companion/blackcurrant.png';
import gooseberryCo from '@/assets/companion/gooseberry.png';
import broccoliCo from '@/assets/companion/broccoli.png';

// Emoji icons mapped to plant names for visual flair
const PLANT_EMOJIS: Record<string, string> = {
  'Aubergine': '🍆', 'Celery': '🥬', 'Chillies': '🌶️', 'Peas': '🫛',
  'Potatoes': '🥔', 'Pumpkins': '🎃', 'Pumpkin': '🎃', 'Broad Beans': '🫘',
  'Mint': '🍃', 'Coriander': '🌿', 'Tarragon': '🌿',
  'Apple Tree': '🍎', 'Pear Tree': '🍐', 'Sweet Peas': '🌸',
  'Dahlia': '🌸', 'Cauliflower': '🥦',
};

// Custom image icons — prefer new watercolor companion set, fall back to legacy emoji-*.
const PLANT_IMAGES: Record<string, string> = {
  // Watercolor companion set (top-down)
  'Basil': basilCo,
  'Beans': beansCo,
  'Runner Beans': beansCo,
  'French Beans': beansCo,
  'Broad Beans': beansCo,
  'Cabbage': cabbageCo,
  'Carrots': carrotCo,
  'Carrot': carrotCo,
  'Courgette': courgetteCo,
  'Courgettes': courgetteCo,
  'Cucumber': cucumberCo,
  'Cucumbers': cucumberCo,
  'Kale': kaleCo,
  'Lettuce': lettuceCo,
  'Marigold': marigoldCo,
  'Marigolds': marigoldCo,
  'Nasturtium': nasturtiumCo,
  'Nasturtiums': nasturtiumCo,
  'Onion': onionCo,
  'Onions': onionCo,
  'Squash': squashCo,
  'Sunflower': sunflowerCo,
  'Sunflowers': sunflowerCo,
  'Sweetcorn': sweetcornCo,
  'Corn': sweetcornCo,
  'Tomato': tomatoCo,
  'Tomatoes': tomatoCo,
  'Pepper': pepperCo,
  'Peppers': pepperCo,
  'Chillies': pepperCo,
  'Chili': pepperCo,
  'Spinach': spinachCo,
  'Garlic': garlicCo,
  'Strawberry': strawberryCo,
  'Strawberries': strawberryCo,
  'Chives': chivesCo,
  'Dill': dillCo,
  'Parsley': parsleyCo,
  'Rosemary': rosemaryCo,
  'Thyme': thymeCo,
  'Sage': sageCo,
  'Oregano': oreganoCo,
  'Lavender': lavenderCo,
  'Beetroot': beetrootCo,
  'Radish': radishCo,
  'Radishes': radishCo,
  'Calendula': calendulaCo,
  'Borage': borageCo,
  'Raspberry': raspberryCo,
  'Raspberries': raspberryCo,
  'Blackcurrant': blackcurrantCo,
  'Blackcurrants': blackcurrantCo,
  'Redcurrant': redcurrantIcon,
  'Redcurrants': redcurrantIcon,
  'Gooseberry': gooseberryCo,
  'Gooseberries': gooseberryCo,
  'Broccoli': broccoliCo,
  // Legacy fallbacks
  'Asparagus': asparagusIcon,
  'Brussels Sprouts': brusselsSproutsIcon,
  'Cauliflower': cauliflowerIcon,
  'Celeriac': celeriacIcon,
  'Kohlrabi': kohlrabiIcon,
  'Parsnips': parsnipIcon,
  'Swiss Chard': swissChardIcon,
  'Turnips': turnipIcon,
  'Globe Artichoke': artichokeIcon,
  'Globe Artichokes': artichokeIcon,
  'Artichoke': artichokeIcon,
  'Leeks': leekIcon,
  'Florence Fennel': fennelIcon,
  'Fennel': fennelIcon,
  'Blackberries': blackberryIcon,
  'Fig': figIcon,
  'Plum Tree': plumIcon,
};

export function getPlantEmoji(name: string): string {
  return PLANT_EMOJIS[name] || '🌱';
}

export function getPlantImage(name: string): string | null {
  return PLANT_IMAGES[name] || null;
}
